module.exports = __webpack_public_path__ + "static/media/photo.90580850.png";